import moment from "moment";
import { Commons } from "../interfaces";
import { capitalizeString, getCityNameByCode } from "../shared/util";

export class CommonsAdapter {
  value: any;

  constructor(input: any) {
    this.value = input;
  }

  get contact_name() {
    return capitalizeString(this.value.contact_name || "");
  }

  get contact_email() {
    return this.value.contact_email || "";
  }

  get update_date() {
    return moment(this.value.update_date).format("YYYY-MM-DD");
  }
  get created_at() {
    return moment(this.value.created_at).format("YYYY-MM-DD");
  }

  get current_date() {
    return moment(this.value.current_date).format("YYYY-MM-DD");
  }

  get issue_date() {
    return moment(this.value.issue_date).format("YYYY-MM-DD");
  }

  get updated_at() {
    return moment(this.value.updated_at).format("YYYY-MM-DD");
  }

  get city() {
    if (!this.value.city) {
      return this.value.cityRaw || "No Informa";
    }

    return getCityNameByCode(this.value.city)?.municipio || "No definido";
  }

  get state() {
    if (!this.value.state) {
      return this.value.stateRaw || "No Informa";
    }
    return getCityNameByCode(this.value.city)?.departamento || "No definido";
  }

  adapt(): Commons {
    console.log("value", this.value);
    return {
      id: this.value.id,
      area_de_conocimiento: this.value.especialidad_de_conocimiento,
      especialidad_de_conocimiento: this.value.area_de_conocimiento,
      gran_area_de_conocimiento: this.value.gran_area_de_conocimiento,
      phone: this.value.phone,
      dependencie_type: this.value.dependencie_type,
      dependencie_value: this.value.dependencie_value,
      descripcion: this.value.descripcion,
      external_code: this.value.external_code,
      features: this.value.features,
      nombre: capitalizeString(this.value.nombre || ""),
      contact_name: this.contact_name,
      contact_email: this.contact_email,
      issue_date: this.issue_date,
      current_date: this.current_date,
      created_at: this.created_at || "",
      updated_at: this.updated_at || "",
      update_date: this.update_date || "",
      actor_type: this.value.actor_type,
      recognized_min: this.value.recognized_min === 1 ? "Si" : "No",
      source: this.value.source || "",
      city: capitalizeString(this.city || ""),
      state: capitalizeString(this.state || ""),
      ciudad: capitalizeString(this.city || ""),
      url: this.value.url || "",
    };
  }
}
